import {createSlice} from "@reduxjs/toolkit";

const initialGuidePublicationsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guidePublicationForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const guidePublicationsSlice = createSlice({
  name: "guidePublications",
  initialState: initialGuidePublicationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuidePublicationById
    guidePublicationFetched: (state, action) => {
      state.actionsLoading = false;
      state.guidePublicationForEdit = action.payload.guidePublicationForEdit;
      state.error = null;
    },
    // findGuidePublications
    guidePublicationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuidePublication
    guidePublicationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guidePublication);
    },
    // updateGuidePublication
    guidePublicationUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiPublicationId === action.payload.guidePublication.guiPublicationId) {
          return action.payload.guidePublication;
        }
        return entity;
      });
    },
    // deleteGuidePublication
    guidePublicationDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiPublicationId !== action.payload.guiPublicationId);
    },
    // deleteGuidePublications
    guidePublicationsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiPublicationId)
      );
    },
  }
});
